// extracted by mini-css-extract-plugin
export default {"centerText":"LLReference_centerText__cznEo","smallHr":"LLReference_smallHr__hvLE1"};